module.exports = __webpack_public_path__ + "img/logo-white.999c2063.png";